<div [ngClass.gt-sm]="'mb-0 p-0 m-b-6'">
    <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate" *ngIf="isListLoading">
    </mat-progress-spinner>
    <ng-container *ngIf="!isListLoading">
        <form [formGroup]="reportFormGroup">
            <div class="p-10" fxLayoutAlign="space-between center">
                <div class="leve-report">
                    <div class="top-fil">
                        <div class="left">
                            <div class="field-set selec">
                                <span class="label-fixer">
                                    <mat-label>Informes predeterminados</mat-label>
                                </span>
                                <mat-form-field appearance="fill">
                                    <mat-select [(value)]="selectedTemplateId"
                                        (selectionChange)="onChangeCompany($event)">
                                        <mat-option *ngFor="let item of reportDropDownList" [value]="item.value">
                                            {{item.viewValue}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <button mat-button (click)="addOrEditReport(selectedTemplateId)">
                                    <mat-icon>save</mat-icon>
                                </button>
                                <button mat-button (click)="deleteReport(selectedTemplateId)">
                                    <mat-icon>delete_forever</mat-icon>
                                </button>
                            </div>
                            <div class="field-set selec selec2">
                                <span class="label-fixer">
                                    <mat-label>Título</mat-label>
                                </span>
                                <mat-form-field class="example-full-width">
                                    <input formControlName="Titulo" matInput>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                    <div class="bottom-card-lister">
                        <div class="card-each">
                            <h3>General</h3>
                            <div class="field-set selec">
                                <mat-label>Idioma</mat-label>
                                <mat-form-field appearance="fill">
                                    <mat-select formControlName="Idioma">
                                        <mat-option value="E">Español </mat-option>
                                        <mat-option value="C">Catalán </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="field-set selec">
                                <mat-label>Orden</mat-label>
                                <mat-form-field appearance="fill">
                                    <mat-select formControlName="Orden">
                                        <mat-option [value]="0">Nombre </mat-option>
                                        <mat-option [value]="1">Fecha Baja</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="field-set selec">
                                <mat-label>Formato</mat-label>
                                <mat-form-field appearance="fill">
                                    <mat-select formControlName="Formato">
                                        <mat-option value="INFORME">Informe </mat-option>
                                        <mat-option value="LISTADO">Listado </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="field-set selec">
                                <mat-label>Salto de página</mat-label>
                                <mat-form-field appearance="fill">
                                    <mat-select formControlName="SaltoPagina">
                                        <mat-option [value]="0">Sin saltos</mat-option>
                                        <mat-option [value]="1">Por empresa</mat-option>
                                        <mat-option [value]="2">Por atributo 1</mat-option>
                                        <mat-option [value]="3">Por trabajador</mat-option>
                                        <mat-option [value]="4">Por puesto</mat-option>
                                        <mat-option [value]="5">Por atributo 2</mat-option>
                                        <mat-option [value]="6">Por atributo 3</mat-option>
                                        <mat-option [value]="7">Por atributo 4</mat-option>
                                        <mat-option [value]="8">Por atributo 5</mat-option>
                                        <mat-option [value]="9">Por atributo 6</mat-option>
                                        <mat-option [value]="10">Por atributo 7</mat-option>
                                        <mat-option [value]="11">Por atributo 8</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="card-each">
                            <h3>Bajas anteriores </h3>
                            <div class="field-set">
                                <mat-checkbox formControlName="BajasAnteriores" class="example-margin">Bajas anteriores
                                </mat-checkbox>
                            </div>
                            <div class="field-set">
                                <mat-checkbox formControlName="ListadoBajasAnt" class="example-margin">Listado de bajas
                                </mat-checkbox>
                            </div>
                            <div class="field-set">
                                <mat-checkbox formControlName="DiasBajasAnt" class="example-margin">Días de baja
                                </mat-checkbox>
                            </div>
                            <div class="field-set">
                                <mat-checkbox formControlName="AcumBajasAnt" class="example-margin">Días acumulados
                                </mat-checkbox>
                            </div>
                            <div class="field-set" *ngIf="permissionList.indexOf(501)!=-1">
                                <mat-checkbox formControlName="DiagnosticoBajasAnt" class="example-margin">Diagnóstico
                                </mat-checkbox> <!-- need permision -->
                            </div>
                            <div class="field-set-wrapper" *ngIf="permissionList.indexOf(407)!=-1">
                                <div class="field-set">
                                    <mat-checkbox formControlName="GraficoBajasAnt" class="example-margin">Gráfico de
                                        bajas
                                    </mat-checkbox>
                                </div>

                                <div class="field-set selec" *ngIf="permissionList.indexOf(407)!=-1">
                                    <mat-label>Años de baja</mat-label>
                                    <mat-form-field appearance="fill">
                                        <mat-select formControlName="AnyosBajasAnt">
                                            <!-- need permision -->
                                            <mat-option [value]="1">1 año </mat-option>
                                            <mat-option [value]="2">2 años </mat-option>
                                            <mat-option [value]="3">3 años </mat-option>
                                            <mat-option [value]="4">4 años </mat-option>
                                            <mat-option [value]="5">5 años </mat-option>
                                            <mat-option [value]="6">Todos los años </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="card-each">
                            <h3>Actuaciones </h3>
                            <div class="field-set">
                                <mat-checkbox formControlName="Actuaciones" class="example-margin">Todas las actuaciones
                                </mat-checkbox>
                            </div>
                            <div class="field-set">
                                <mat-checkbox formControlName="UltimaVisita" class="example-margin">Última visita
                                </mat-checkbox>
                            </div>
                            <div class="field-set" *ngIf="permissionList.indexOf(510)!=-1">
                                <mat-checkbox formControlName="MedicoVisita" class="example-margin">Médico en visitas
                                </mat-checkbox> <!-- need permision -->
                            </div>
                            <div class="field-set" *ngIf="permissionList.indexOf(501)!=-1">
                                <mat-checkbox formControlName="TextoActuacion" class="example-margin">Texto de la
                                    actuación</mat-checkbox> <!-- need permision -->
                            </div>
                            <div class="field-set">
                                <mat-checkbox formControlName="UltimaGestion" class="example-margin">Gestiones a partir
                                    última visita</mat-checkbox>
                            </div>
                            <div class="field-set">
                                <mat-checkbox formControlName="diferenciarVisitaContacto" class="example-margin">
                                    Diferenciar visita / contacto</mat-checkbox>
                            </div>
                            <div class="field-set">
                                <mat-checkbox formControlName="Solicitudes" class="example-margin">Solicitudes
                                </mat-checkbox>
                            </div>
                            <div class="field-set" *ngIf="permissionList.indexOf(513)!=-1">
                                <mat-checkbox formControlName="ComentarioParaEmpresa" class="example-margin">Comentarios
                                    para la empresa</mat-checkbox> <!-- need permision -->
                            </div>

                            <div class="field-set" *ngIf="permissionList.indexOf(508)!=-1">
                                <mat-checkbox formControlName="ComentariosInternos" class="example-margin">Comentarios
                                    internos</mat-checkbox> <!-- need permision -->
                            </div>
                            <div class="field-set" *ngIf="permissionList.indexOf(508)!=-1">
                                <mat-checkbox formControlName="ComentariosExternos" class="example-margin">Comentarios
                                    externos</mat-checkbox> <!-- need permision -->
                            </div>
                            <div class="field-set" *ngIf="permissionList.indexOf(513)!=-1">
                                <mat-checkbox formControlName="UltimoComentario" class="example-margin">Comentarios a
                                    partir última visita</mat-checkbox> <!-- need permision -->
                            </div>
                        </div>


                        <div class="card-each">
                            <h3>Baja actual</h3>
                            <div class="field-set">
                                <mat-checkbox formControlName="BajaActual" class="example-margin">Baja actual
                                </mat-checkbox>
                            </div>
                            <div class="field-set">
                                <mat-checkbox formControlName="ExcluirNoVisitar" class="example-margin">Excluir no
                                    visitar</mat-checkbox>
                            </div>
                            <div class="field-set">
                                <mat-checkbox formControlName="TipoBaja" class="example-margin">Tipo de baja
                                </mat-checkbox>
                            </div>
                            <div class="field-set">
                                <mat-checkbox formControlName="AvisoBaja" class="example-margin">Aviso de la baja
                                </mat-checkbox>
                            </div>
                            <div class="field-set">
                                <mat-checkbox formControlName="Inspeccion" class="example-margin">Inspección
                                </mat-checkbox>
                            </div>
                            <div class="field-set">
                                <mat-checkbox formControlName="NoJustificada" class="example-margin">Justificada
                                </mat-checkbox>
                            </div>
                            <div class="field-set" *ngIf="permissionList.indexOf(505)!=-1">
                                <mat-checkbox formControlName="DiagnosticoBaja" class="example-margin">Diagnóstico
                                </mat-checkbox> <!-- need permision -->
                            </div>
                            <div class="field-set">
                                <mat-checkbox formControlName="ActitudNegativa" class="example-margin">Actitud negativa
                                </mat-checkbox>
                            </div>
                            <div class="field-set" *ngIf="permissionList.indexOf(501)!=-1">
                                <mat-checkbox formControlName="ObsBaja" class="example-margin">Observaciones
                                </mat-checkbox> <!-- need permision -->
                            </div>
                        </div>
                        <div class="card-each">
                            <h3>Días de baja</h3>
                            <div class="field-set">
                                <mat-checkbox formControlName="DiasBaja" class="example-margin">Días de baja
                                </mat-checkbox>
                            </div>
                            <div class="field-set">
                                <mat-checkbox formControlName="FPA" class="example-margin">Fecha prevista de alta
                                </mat-checkbox>
                            </div>
                            <div class="field-set">
                                <mat-checkbox formControlName="DiasPrevistos" class="example-margin">Días previstos
                                </mat-checkbox>
                            </div>
                            <div class="field-set">
                                <mat-checkbox formControlName="GraficoDiasBaja" class="example-margin">Gáfico de días de
                                    baja</mat-checkbox>
                            </div>
                            <div class="field-set" *ngIf="permissionList.indexOf(407)!=-1">
                                <mat-checkbox formControlName="DiasAcum" class="example-margin">Días acumulados
                                </mat-checkbox> <!-- need permision -->
                            </div>
                            <div class="field-set" *ngIf="permissionList.indexOf(407)!=-1">
                                <mat-checkbox formControlName="DiasAcum180" class="example-margin">No solo recaidas en
                                    acumulados</mat-checkbox> <!-- need permision -->
                            </div>
                            <div class="field-set" *ngIf="permissionList.indexOf(407)!=-1">
                                <mat-checkbox formControlName="GraficoDiasAcum" class="example-margin">Gráfico de días
                                    acumulados</mat-checkbox> <!-- need permision -->
                            </div>
                        </div>
                        <div class="card-each">
                            <h3>Trabajador</h3>
                            <div class="field-set">
                                <mat-checkbox formControlName="Empresa" class="example-margin">Empresa</mat-checkbox>
                            </div>
                            <div class="field-set" *ngIf="permissionList.indexOf(305)!=-1">
                                <mat-checkbox formControlName="Absentista" class="example-margin">Absentista
                                </mat-checkbox> <!-- need permision -->
                            </div>
                            <div class="field-set" *ngIf="permissionList.indexOf(306)!=-1">
                                <mat-checkbox formControlName="PuestoUrgente" class="example-margin">Puesto urgente
                                </mat-checkbox> <!-- need permision -->
                            </div>
                            <div class="field-set">
                                <mat-checkbox formControlName="Poblacion" class="example-margin">Dirección, atributos y
                                    NIF</mat-checkbox>
                            </div>
                            <div class="field-set">
                                <mat-checkbox formControlName="Edad" class="example-margin">Edad</mat-checkbox>
                            </div>
                        </div>

                        <div class="card-each card-each-low">
                            <h3>Tareas</h3>
                            <div class="field-set">
                                <mat-checkbox formControlName="Tareas" class="example-margin">Tareas médicas
                                </mat-checkbox>
                            </div>
                            <div class="field-set">
                                <mat-checkbox formControlName="TareasTebex" class="example-margin">Tareas gestion
                                </mat-checkbox>
                            </div>
                            <div class="field-set" *ngIf="permissionList.indexOf(510)!=-1">
                                <mat-checkbox formControlName="AutorTarea" class="example-margin">Autor</mat-checkbox>
                                <!-- need permision -->
                            </div>
                        </div>
                        <div class="card-each card-each-low">
                            <h3>Costes </h3>
                            <div class="field-set" *ngIf="permissionList.indexOf(307)!=-1">
                                <mat-checkbox formControlName="CosteAbsentismo" class="example-margin">Coste de
                                    absentismo</mat-checkbox> <!-- need permision -->
                            </div>
                            <div class="field-set" *ngIf="permissionList.indexOf(307)!=-1">
                                <mat-checkbox formControlName="CosteIndemnizacion" class="example-margin">Coste de
                                    indemnización</mat-checkbox> <!-- need permision -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </ng-container>
</div>